<template>
    <progress :max="total" :value="current"></progress>
</template>

<script>
    import Widget from './Widget';

    export default {
        extends: Widget,
        props: {
            current: Number,
            total: Number
        },
    }
</script>
